const batteryList = () => import('@/pages/battery/index.vue');
const batteryForm = () => import('@/pages/battery/form.vue');

export default [{
    path: '/battery/list',
    component: batteryList,
    meta: [{
        name: '电池管理'
    },
    {
        name: '电池列表',
        activeRoute: '/battery/list'
    }]
}, {
    path: '/battery/form',
    component: batteryForm,
    meta: [{
        name: '电池管理'
    },
    {
        name: '电池列表',
        url: '/battery/list'
    },
    {
        name: '添加/编辑',
        activeRoute: '/battery/list'
    }]
}];